@if (!editMode) {
  <div class="main-content">
    @if (imageSrc !== undefined) {
      <img [src]="imageSrc" class="small-image" [style]="fieldConfig?.entryCss" />
    }
    @if (imageSrc) {
      <mat-icon
        matSuffix
        class="clipboard-copy"
        [ngClass]="{ 'clipboard-copied': this.clipboardCopied }"
        matTooltip="Copy to clipboard"
        (click)="copyToClipboard()"
        >file_copy
      </mat-icon>
    }
    @if (imageSrc === undefined) {
      <div>No Image</div>
    }
  </div>
} @else {
  <div class="form-content">
    @if (imageSrc !== undefined) {
      <img [src]="imageSrc" class="small-image" [style]="fieldConfig?.entryCss" />
    }
    <mat-form-field [formGroup]="formGroup">
      <input
        [matTooltipDisabled]="!this.fieldConfig.requiresKicktheDirectory"
        matTooltip="This field requires relative path starting from Google storage kickthe directory."
        #imgInput
        formControlName="{{ fieldConfig.name }}"
        matInput
        value="No Image"
        (keyup)="refreshImage()" />
      @if (imageSrc) {
        <mat-icon
          matSuffix
          class="clipboard-copy"
          [ngClass]="{ 'clipboard-copied': this.clipboardCopied }"
          matTooltip="Copy to clipboard"
          (click)="copyToClipboard()"
          >file_copy
        </mat-icon>
      }
      @if (editMode) {
        <mat-icon matSuffix class="clear-icon" matTooltip="Clear" (click)="clearField()">clear </mat-icon>
      }
      @if (this.formGroup.get(this.fieldConfig.name).hasError('requiresKicktheDirectory')) {
        <mat-error> Image source needs to be in Google storage assets folder </mat-error>
      }
    </mat-form-field>
  </div>
}
